// Vite는 최신 브라우저를 타겟으로 하므로 react-app-polyfill 불필요
import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/dist/locale-data/en';
import '@formatjs/intl-relativetimeformat/polyfill';
import '@formatjs/intl-relativetimeformat/dist/locale-data/en';

import React, {useEffect} from 'react';
import {BrowserRouter, useLocation} from 'react-router-dom';
import {ApolloProvider} from '@apollo/client';

import {apolloClient} from './apollo';
import Head from './component/head/Head';
import Footer from './component/footer/Footer';
import Navigation from './component/navigation/Navigation';
import StagingRibbon from './component/stagingRibbon/StagingRibbon';
import AutoLogin from "./component/autoLogin/AutoLogin";
import AppInstallModal from "./component/appInstallModal/AppInstallModal";
import {launchAppStore} from './util/appLink';
import CustomToast from "./component/toast/CustomToast";
import {scheduleClarityLoad} from "./util/clarity";

import './App.css';
import AppRoutes from "./component/routes/AppRoutes";
import {isStandaloneLayoutPath} from "./component/routes/routeLayout";

function AppShell() {
    const {pathname} = useLocation();
    const isStandaloneLayout = isStandaloneLayoutPath(pathname);

    return (
        <>
            {!isStandaloneLayout && (
                <Navigation hostname={window.location.hostname} userAgent={window.navigator.userAgent} />
            )}
            <main className={`App-content${isStandaloneLayout ? ' App-content--standalone' : ''}`}>
                <AppRoutes hostname={window.location.hostname}
                           userAgent={window.navigator.userAgent} />
            </main>
            {!isStandaloneLayout && <Footer />}
            {/* components which are not present in App.ssr should be last */}
            <StagingRibbon hostname={window.location.hostname} />
            <AppInstallModal />
            <AutoLogin />
            <CustomToast />
        </>
    );
}

export default function App() {
    // redirect to the app store if requested by a location url parameter
    // run only once during the app initialization
    useEffect(() => {
        launchAppStore(window.history, window.location, window.navigator.userAgent);
        scheduleClarityLoad();
    }, []);

    return (
        <ApolloProvider client={apolloClient}>
            <Head hostname={window.location.hostname}/>
            <BrowserRouter>
                <AppShell />
            </BrowserRouter>
        </ApolloProvider>
    );
}
